export function delayPromise(millis: number): Promise<void> {
  return new Promise<void>(resolve => setTimeout(resolve, millis));
}
